import { getStore } from '../../../helpers/initStore.js';
import { getNurseAvailabilitiesOrFailure, getNurseFillProbabilityFailure } from './helpers/nurse.js';
import { getTimeSlotDebugInfo } from './helpers/utilities.js';
import { getIsDebugMode } from '../../variables/helpers.js';

/**
 * Nurse filter conditions checked for each time slot:
 * 1. Nurse active flag true
 * 2. A nurse with a centrifuge exists if necessary
 * 3. Office is willing to accept a pending nurse
 * 4. The nurse's offerDeadline is still in the future
 * 5. The expected acceptance rate is above the office threshold
 *
 * Here, we also set the remaining available nurses for each time slot.
 */
const getNurseFilteredTimeSlots = (timeSlotsByDate, schedulingConfig) => {
    const store = getStore();
    const isDebugMode = getIsDebugMode();
    const timeSlotsByDateObject = {};
    const { enablePendingNurseID, visitFillThreshold } = schedulingConfig.baseScheduling;
    Object.entries(timeSlotsByDate).map(([date, timeSlotsByTime]) => {
        Object.entries(timeSlotsByTime).map(([time, timeSlot]) => {
            var _a;
            if (timeSlot.disabled) {
                timeSlotsByDateObject[date] = {
                    ...timeSlotsByDateObject[date],
                    [time]: timeSlot,
                };
                return;
            }
            const failures = [];
            const slot = timeSlot;
            const timeSlotHelperParams = store.getters['schedulingFlow/getTimeSlotHelperParams'](timeSlot);
            if (!timeSlotHelperParams)
                return;
            // Filter out inactive nurses, pending nurses (if applicable), or ones
            // that don't have a centrifuge if required
            const nurseAvailabilitiesOrFailure = getNurseAvailabilitiesOrFailure(timeSlotHelperParams, enablePendingNurseID);
            // If there is no failure, we will have the filtered nurses
            if (typeof nurseAvailabilitiesOrFailure === 'string') {
                failures.push(nurseAvailabilitiesOrFailure);
            }
            else {
                // Check that the expected fill probability for the time slot is above
                // the office threshold
                const nurses = nurseAvailabilitiesOrFailure;
                const nurseFillProbabilityFailure = getNurseFillProbabilityFailure(timeSlotHelperParams, nurses, visitFillThreshold);
                if (nurseFillProbabilityFailure) {
                    failures.push(nurseFillProbabilityFailure);
                }
                else {
                    slot.availableNurses = nurses;
                }
            }
            const timeSlotsForDate = (_a = timeSlotsByDateObject[date]) !== null && _a !== void 0 ? _a : {};
            if (!failures.length)
                timeSlotsForDate[time] = slot;
            if (failures.length && isDebugMode)
                timeSlotsForDate[time] = getTimeSlotDebugInfo(slot, failures);
            timeSlotsByDateObject[date] = timeSlotsForDate;
        });
    });
    return timeSlotsByDateObject;
};

export { getNurseFilteredTimeSlots };
